import {
    Input as HeadlessUIInput,
    InputProps as HeadlessUIInputProps,
} from "@headlessui/react";
import { ElementType } from "react";

function BaseInput({ className, ...rest }: HeadlessUIInputProps) {
    return (
        <HeadlessUIInput
            className={`rounded-md shadow-xs border border-gray-300 focus:border-gray-300 focus:ring-3 focus:ring-gray-200/50 peer ${
                className ?? ""
            }`}
            {...rest}
        />
    );
}

interface InputProps extends HeadlessUIInputProps {
    Icon?: ElementType;
    iconPosition?: "left" | "right";
}
export default function Input({
    className,
    Icon,
    iconPosition = "left",
    ...rest
}: InputProps) {
    if (Icon) {
        return (
            <div className="relative mt-1 rounded-md w-fit">
                <div
                    className={`pointer-events-none absolute inset-y-0 ${iconPosition === "left" ? "left-0" : "right-4"} flex items-center pl-3`}
                >
                    <Icon className="size-4" />
                </div>
                <BaseInput
                    className={`${className} ${iconPosition === "left" ? "pl-10" : "pr-10 pl-4"}`}
                    {...rest}
                />
            </div>
        );
    }

    return <BaseInput className={className} {...rest} />;
}
